import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  AddEnvironmentVariableRequestType,
  AddEnvironmentVariableResponseType
} from "./types";

export const addEnvironmentVariableRequest = ({
  data,
  projectId,
  environmentId
}: AddEnvironmentVariableRequestType) =>
  apiProxyRequest<AddEnvironmentVariableResponseType>(
    `/projects/${projectId}/environments/${encodeURIComponent(environmentId)}/variables`,
    "POST",
    data
  );
